const AppConfig = {
  // মূল Flask API সার্ভার
  API_BASE_URL: 'https://nilachol-cafe-restaurant-main-server.sparkx-ai.shop/',
  CompanyName: 'Nilachol Cafe & Restaurant',
  phoneNumber: '01308033644',
  contactEmail: 'contact@nilachol.com',
  // WhatsApp লিঙ্ক
  WhatsAppLink: 'https://wa.me/01356045689',
  WhatsAppNumber: '+8801356045689',
  // Facebook Messenger লিঙ্ক
  MessengerLink: 'https://m.me/nilacholcaferestaurant',
  // WhatsApp ডিফল্ট মেসেজ
  WhatsAppDefaultMessage: 'Hello! I visited your website and would like some information.',
  DeliveryManURL: 'https://nilachol-cafe-restaurant-main-server.sparkx-ai.shop/delivery-man',
  WELCOME_COUPON_CODE: 'WELCOME10', // নতুন ব্যবহারকারীদের জন্য
};

export default AppConfig;